import "./Hr.css";
import React from "react";

function Hr({ color = "var(--dark-blue)", margin = "20px 0" }) {
  return <hr className='hr' style={{ "--background-color": color, "--margin": margin }} />;
}

export default Hr;
